import { queryKeys } from "@/lib/data/static/query-keys";
import { type APIResponse } from "@/lib/types";
import { useInfiniteQuery } from "@tanstack/react-query";

type MatterPageRequest = {
  matterId: string;
  pageNumber: number;
  pageSize: number;
};

export const useMatterInfinitePages = <T>({
  matterId,
  queryKey,
  queryFn,
  pageSize = 1000,
}: {
  matterId: string;
  queryKey: string;
  queryFn: (params: MatterPageRequest) => Promise<APIResponse<T[]>>;
  pageSize?: number;
}) => {
  return useInfiniteQuery({
    queryKey: [queryKeys.matters, matterId, queryKey, "infinite", pageSize],
    enabled: Boolean(matterId),
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      queryFn({ matterId, pageNumber: pageParam, pageSize }),
    getNextPageParam: (lastPage, allPages) => {
      const pageNumber = lastPage.pagination?.pageNumber ?? allPages.length;
      const returnedPageSize = lastPage.pagination?.pageSize ?? pageSize;
      const count = lastPage.pagination?.count;

      if (count !== undefined && count > 0) {
        return pageNumber * returnedPageSize < count
          ? pageNumber + 1
          : undefined;
      }

      return lastPage.data.length === returnedPageSize
        ? pageNumber + 1
        : undefined;
    },
  });
};
